import { PostMethod } from '../../serviceHelper';

const getMethods = (service: 'workflow', controller: 'Delegation') => ({
	Disable: new PostMethod<any, any>({
		service,
		controller,
		method: 'Disable'
	}),
	Edit: new PostMethod<any, any>({
		service,
		controller,
		method: 'Edit'
	}),
	Create: new PostMethod<any, any>({
		service,
		controller,
		method: 'Create'
	}),
	GetTakenDelegations: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetTakenDelegations'
	}),
	GetGivenDelegations: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetGivenDelegations'
	}),
	Regenerate: new PostMethod<any, any>({
		service,
		controller,
		method: 'Regenerate'
	}),
	Get: new PostMethod<any, { secretKey: string }>({
		service,
		controller,
		method: 'Get'
	}),
	MultiDisable: new PostMethod<any, any>({
		service,
		controller,
		method: 'MultiDisable'
	})
});

export { getMethods };
